import React from "react";

export default class Logout extends React.Component {
  //This component is used in order for the user to be able to logout.

  componentDidMount() {
    this.props.history.push("/");
  }

  render() {
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Logout.js